import React, { DetailedHTMLProps, ButtonHTMLAttributes, PropsWithChildren, HTMLAttributes } from 'react';
import { clsx } from 'clsx';

import { INPUT_MAX_LENGTH } from '../../constants/choice-button-text-area-input';

import { Button } from '../Button';
import { TextAreaInput } from '../TextAreaInput';

import styles from './SingleChoiceButton.module.scss';

export interface ISingleChoiceButtonLabelProps extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
    label: string;
}

export interface ISingleChoiceButtonOption extends ISingleChoiceButtonLabelProps {
    value: string;
    userAnswer?: string;
    setUserAnswer?: (text: string) => void;
    maxLength?: number;
}

export interface ISingleChoiceButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>{
    option: ISingleChoiceButtonOption;
    selected: boolean;
}

export interface ISingleChoice {
    options: ISingleChoiceButtonOption[];
    selectedOption: ISingleChoiceButtonOption;
    onSelect: (option: ISingleChoiceButtonOption) => void;
    buttonWrapperClass?: string;
}

export const SingleChoicesButtonWrapper = ({ children }: PropsWithChildren) => <div className={styles.singleChoicesWrapper}> {children} </div>;

export const SingleChoiceButton = ({ children, option, selected, className, ...props }: ISingleChoiceButtonProps) => {

    const textAreaShown = selected && option.setUserAnswer;
    const maxLength = option.maxLength || INPUT_MAX_LENGTH;

    return (
        <div className={clsx(className)}>
            <Button
                wrapperClass={styles.wrapper}
                buttonClass={clsx(styles.singleChoiceButton, selected && styles.singleChoiceSelected)}
                {...props}>
                    {children}
            </Button>

            {textAreaShown && <TextAreaInput
                wrapperClass={styles.textAreaInputWrapper}
                placeholder={option.placeholder || ''}
                onChange={(event) => option.setUserAnswer ? option.setUserAnswer(event.target.value) : () => {}}
                value={option.userAnswer || ''}
                maxLength={maxLength} />
            }
        </div>
    );
};

export const SingleChoicesButtonLabel = ({ label }: ISingleChoiceButtonLabelProps) => <span className={styles.singleChoiceText}>{label}</span>;

export const SingleChoice = ({ options, selectedOption, onSelect, buttonWrapperClass }: ISingleChoice) => {
    return (
        <SingleChoicesButtonWrapper>
            {options.map((option) => (
                <SingleChoiceButton
                    key={option.value}
                    option={option}
                    selected={option.value === selectedOption.value}
                    onClick={() => onSelect(option)}
                    className={buttonWrapperClass}>
                    <SingleChoicesButtonLabel label={option.label} />
                </SingleChoiceButton>
            ))}
        </SingleChoicesButtonWrapper>
    );
};
